// useActiveSolutions.js
import { computed } from "vue";
import { useEnabledSolutions } from "@/composables";
import {
  ARC_SERVICE,
  PHISHING_SIMULATION,
  SAT_SERVICE,
  PHISH_SERVICE,
  SEG_SERVICE,
} from "@/utils/services";

export const useActiveSolutions = () => {
  const { enabledSolutions } = useEnabledSolutions();

  const activeSolutions = computed(() => {
    return enabledSolutions.value
      .filter(
        (solution: { solution_uuid: string }) =>
          solution.solution_uuid === ARC_SERVICE ||
          solution.solution_uuid === PHISHING_SIMULATION ||
          solution.solution_uuid === SAT_SERVICE ||
          solution.solution_uuid === PHISH_SERVICE ||
          solution.solution_uuid === SEG_SERVICE,
      )
      .map((solution: { solution_uuid: string }) => solution.solution_uuid);
  });

  const isSolutionActive = (solutionId: string) => {
    return activeSolutions.value.includes(solutionId);
  };

  // Return both activeSolutions and isSolutionActive
  return {
    activeSolutions,
    isSolutionActive,
  };
};
